(function () {
  
function randInt(max) {
  return Math.floor(Math.random() * max);
}

function show(element) {
  element.style.display = 'flex';
}

function hide(element) {
  element.style.display = 'none';
}

function assembleTweetText(prefix, commitMessage) {
  // Reserve a margin for URL etc
  var limit = 200;
  var commitMessageLimit = limit - prefix.length;

  if (commitMessage.length > commitMessageLimit) {
    commitMessage = commitMessage.slice(0, commitMessageLimit - 1) + '…'
  }

  return prefix + ' "' + commitMessage + '"';
}

function setupCommitMessageDisplay(display) {
  // Nodelist to array
  var items = Array.prototype.slice.call(display.querySelectorAll('.commit-messages__item'));
  // Make a shallow copy
  var origItems = items.slice();
  var randomButton = display.querySelector('.commit-messages__random');
  var tweetButton = display.querySelector('.commit-messages__tweet');
  var active, prevActive;

  function showRandom() {
    if (items.length == 0) {
      items = origItems.slice();
    }

    prevActive = active;
    active = items.splice(randInt(items.length), 1)[0];
    if (prevActive) { hide(prevActive) }
    show(active);
  }

  showRandom();

  randomButton.addEventListener('click', function (event) {
    event.preventDefault();
    showRandom();
  });

  tweetButton.addEventListener('click', function (event) {
    event.preventDefault();
    
    if (!active) { return }

    FN.socialShare(
      'twitter',
      null,
      assembleTweetText(
        tweetButton.dataset.tweetPrefix,
        active.dataset.commitMessage
      )
    );
  });
}

function setupCommitMessageDisplays() {
  var commitMessageDisplays = document.querySelectorAll('.commit-messages');
  var i;

  for (i = 0; i < commitMessageDisplays.length; i++) {
    setupCommitMessageDisplay(commitMessageDisplays[i]);
  }
}

$(document).ready(setupCommitMessageDisplays);

})();
